module.exports = __webpack_public_path__ + "img/wa_wiz_side_clip.f423f870.jpg";